import { Injectable } from '@angular/core';
import { ViewportRuler } from '@angular/cdk/overlay';

@Injectable({
  providedIn: 'root'
})
export class Px2RemService {
  constructor( private viewportRuler: ViewportRuler) {
  }



  px2rem(px: number): string {
    const viewportWidth = this.viewportRuler.getViewportSize().width;
    // viewport width is mobile phone size, can't format
    if(!viewportWidth || viewportWidth <= 767 ){
      return px + 'px';
    } 
    const scale = (viewportWidth / 1920)
    return ((px * scale))?.toFixed(3) + 'px';
}
  convertPX(px: number): number {
    const viewportWidth = this.viewportRuler.getViewportSize().width;
    if(!viewportWidth){
      return px;
    } 
    const scale = (viewportWidth / 1920)
    return ((px * scale));
  }
}

